import IdField from 'modules/shared/fields/idField';
import StringField from 'modules/shared/fields/stringField';

export const OidcModel = {
  fields: {
    id: new IdField('id', 'id'),
    base_url: new StringField('base_url', 'Base URL', { required: true }),
    client_id: new StringField('client_id', 'Client ID', { required: true }),
    client_secret: new StringField('client_secret', 'Client Secret', {
      required: true,
    }),
  },
};
